import { Box, Container, Typography } from "@mui/material";
import React from "react";

export default function ForbiddenView() {

	return (
		<Container>
			<Typography variant="h2">Forbidden</Typography>
			<Typography>You are not authorized to access the page you requested.</Typography>
		</Container>
	);
};